<script setup>
const props = defineProps({
  title: { type: String, required: true },
  subtitle: { type: String, required: true },
  icon: { type: String, required: true },
  features: { type: Array, required: true },
  price: { type: Number, required: true },
  minPrice: { type: Number, required: true },
  maxPrice: { type: Number, required: true },
  recommendedMin: { type: Number, required: true },
  recommendedMax: { type: Number, required: true },
  iconBgColor: { type: String, default: 'bg-blue-100' },
  iconTextColor: { type: String, default: 'text-blue-600' },
  sliderAccentColor: { type: String, default: 'accent-blue-600' },
  priceBgColor: { type: String, default: 'bg-gray-50' },
  borderColor: { type: String, default: 'border-gray-200' },
})

const emit = defineEmits(['update:price'])
</script>

<template>
  <div :class="['bg-white border-2 rounded-2xl p-8 transition-all', borderColor]">
    <div class="grid lg:grid-cols-2 gap-8">
      <!-- Left Side: Icon, Title, Features -->
      <div class="flex flex-col">
        <div class="flex items-center gap-4 mb-6">
          <div :class="['w-16 h-16 rounded-2xl flex items-center justify-center flex-shrink-0', iconBgColor]">
            <span :class="['material-symbols-outlined text-3xl', iconTextColor]">{{ icon }}</span>
          </div>
          <div>
            <h3 class="text-2xl font-bold text-gray-900">{{ title }}</h3>
            <p class="text-sm text-gray-500">{{ subtitle }}</p>
          </div>
        </div>

        <div class="space-y-3">
          <div v-for="(feature, index) in features" :key="index" class="flex items-center gap-3">
            <span class="material-symbols-outlined text-green-500 text-xl">check_circle</span>
            <span :class="['text-sm text-gray-700', feature.bold ? 'font-semibold' : '']">{{ feature.text }}</span>
          </div>
        </div>
      </div>

      <!-- Right Side: Slider and Price -->
      <div class="flex flex-col justify-center">
        <div class="space-y-6">
          <div>
            <div class="flex justify-between items-center mb-4">
              <span class="text-sm font-semibold text-gray-700">Weekly Price</span>
              <span class="text-xs text-gray-500 bg-gray-100 px-3 py-1 rounded-full">
                Recommended: £{{ recommendedMin }}-{{ recommendedMax }}
              </span>
            </div>

            <div class="relative mb-4">
              <input
                type="range"
                :min="minPrice"
                :max="maxPrice"
                :value="price"
                disabled
                :class="['w-full h-3 bg-gray-200 rounded-lg appearance-none cursor-not-allowed opacity-60', sliderAccentColor]"
              >
              <div class="flex justify-between text-xs text-gray-500 mt-2">
                <span>£{{ minPrice }}</span>
                <span>£{{ maxPrice }}</span>
              </div>
            </div>
          </div>

          <div :class="['text-center rounded-xl py-6', priceBgColor]">
            <span class="text-5xl font-bold text-gray-900">£{{ price }}</span>
            <span class="text-gray-500 text-xl ml-2">/lesson</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
